import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';
import { UUID } from '../../util/prototypes';


export class CustomClass {

    constructor(payload) {
        if (payload) {
            this.doc = payload.doc;
            this.name = payload.name;
            this.timestamp = payload.timestamp;
            this.user = new User(payload.user);
            this.uid = this.user.uid;
        } else {
            this.doc = null;
            this.name = '';
            this.timestamp = firebase.firestore.FieldValue.serverTimestamp();
            const { user } = JSON.parse(localStorage.getItem('authUser'));
            this.user = new User(user);
            this.uid = this.user.uid;
        }
        this.screen = 'lg';
    }

    get id() {
        return this.doc ? this.doc.id : null;
    }

    static addClass(stylename, css) {
        let stylsheet = null;
        const style = document.querySelector('#'+stylename);
        stylsheet = style ? style : document.createElement("style");
        stylsheet.setAttribute("type", "text/css");
        stylsheet.setAttribute("id", stylename);
        stylsheet.innerText = css;
        const head = document.querySelector("head")
        head.appendChild(stylsheet);
        console.log(head);
    }

    getMediaQuery(css) {
        /*==========  Mobile First Method  ==========*/
        /* Custom, iPhone Retina */
        // @media only screen and (min-width : 320px) {

        // }

        /* Extra Small Devices, Phones */
        // @media only screen and (min-width : 480px) {

        // }

        /* Small Devices, Tablets */
        // @media only screen and (min-width : 768px) {

        // }

        /* Medium Devices, Desktops */
        // @media only screen and (min-width : 992px) {

        // }

        /* Large Devices, Wide Screens */
        // @media only screen and (min-width : 1200px) {

        // }
        if (this.screen.toLocaleLowerCase() == 'xs') {
            return `@media only screen and (min-width : 320px) {${css}}`
        }
        else if (this.screen.toLocaleLowerCase() == 'sm') {
            return `@media only screen and (min-width : 480px) {${css}}`
        }
        else if (this.screen.toLocaleLowerCase() == 'md') {
            return `@media only screen and (min-width : 768px) {${css}}`
        }
        else if (this.screen.toLocaleLowerCase() == 'lg') {
            return `@media only screen and (min-width : 992px) {${css}}`
        }
        else if (this.screen.toLocaleLowerCase() == 'xl') {
            return `@media only screen and (min-width : 1200px) {${css}}`
        }
    }



    toJson() {
        const obj = {};
        Object.assign(obj, { ...this, user: this.user.toJson() });
        delete obj['doc'];
        return obj;
    }

    update() {
        const data = this.toJson();
        Object.keys(data).forEach((key) => {
            if (Array.isArray(data[key])) {
                data[key] = [...data[key].map((item) => ({ ...item }))];
            }
        })
        this.doc.ref.update(data);
    }

    remove() {
        return this.doc.ref.delete();
    }

}
